import { useEffect, useState } from 'react';
import P, { shape } from 'prop-types';
import { Box, MetaBox } from './styles';
import { maskCurrency } from '../../utils/masks';

const FrameMetricsByChannel = ({data, selectedChannelName, selectedChannelId, metricsConversao, metricsComissao}) => {
    const [values, setValues] = useState(
        {
            getMetaText : null,
            getMetaConversao : null,
            getValorMeta : null,
        }
    );

    const RenderItem = (field) => 
        (
            data?.map((item) => (
                <ul>
                    <div className="hover-container">
                        <li style={{listStyle: 'none'}}>{item[field]}</li>
                    </div>
                </ul>
            ))
        )
    
    const CalcMetaBatida = () => {
        const conversaoNumber = Number(metricsConversao?.replace('%','').replace(',','.'));
        const commissao = data?.filter(f => Number(f.conversao) <= conversaoNumber)
            .sort((a, b) => b.conversao - a.conversao);
        
        if (commissao?.length > 0) {
            const valorMeta = ( Number(metricsComissao?.replace('R$','').replace(',','.')) * 
                (commissao[0].reduce_percent / 100) ) *
                (commissao[0].media / 100);
            console.log(commissao);
            
            setValues({
                getMetaText: commissao[0].tipo,
                getMetaConversao: commissao[0].conversao,
                getValorMeta: maskCurrency(valorMeta)
            });
        }
    }

    useEffect(() => {
        CalcMetaBatida();
    }, [data]); // Certifique-se de passar um array de dependências correto

    return (
        <>
            <br/><br/>
            
                {selectedChannelName == null && (
                    <Box>
                        <h4>Para apresentar os dados de Métricas é necessário selecionar um canal</h4>
                    </Box>
                )}

                { selectedChannelName && (
                <>
                    <h3>Métricas [{selectedChannelName}]</h3>
                    <Box>
                        <h3>Tipo</h3>
                        {RenderItem('tipo')}
                    </Box>

                    <Box>
                        <h3>Média Comissão</h3>
                        {RenderItem('media')}
                    </Box>

                    <Box>
                        {selectedChannelId == 4 ?
                            <>
                            <h3>Perda</h3>
                            {RenderItem('perda')}
                            </> :
                            <>
                            <h3>Conversão</h3>
                            {RenderItem('conversao')}
                            </>
                        }                 
                    </Box>

                    <Box>
                        <h3>Ganho %</h3>
                        {RenderItem('media')}
                    </Box>

                    <p>
                        
                        
                        <MetaBox>META ATUAL ALCANÇADA</MetaBox>
                        {values.getMetaConversao > 0 ? 
                            <>
                                <MetaBox className='metaBoxBKColorGreen'>{values.getMetaText}</MetaBox>
                                <MetaBox className='metaBoxBKColorGreen'>{values.getValorMeta}</MetaBox>
                            </> :
                            <>
                                <MetaBox className='metaBoxBKColorRed'>META NÂO BATIDA</MetaBox>
                                <MetaBox className='metaBoxBKColorRed'>{values.getValorMeta}</MetaBox>
                            </>
                        } 
                        
                    </p>
                </>
            )}
        </>
    )
}

FrameMetricsByChannel.propTypes = {
    data: P.arrayOf(
      shape({
        id: P.number,
        value: P.string,
      })
    ),
    selectedChannelName: P.string,
    selectedChannelId: P.number,
    metricsConversao: P.string,
    metricsComissao: P.string,
};

FrameMetricsByChannel.defaultProps = {
    data: null,
    selectedChannelName: null,
    selectedChannelId: null,
    metricsConversao: null,
    metricsComissao: null,
};

export default FrameMetricsByChannel;
